import { ComponentType } from "./component-type";
import { measurePerformance } from "./performance-observer-utils";
import { StructuredLog } from "@agentx/agentx-services";
const RenderLifecyclePerformanceMeasure = "render-lifecycle";
function measureLitElementPerformance(name, customElementConstructor) {
    measurePerformance(name, customElementConstructor, {
        startFunction: "update",
        endFunction: "updated",
        name: RenderLifecyclePerformanceMeasure
    });
}
function measureReactClassComponentPerformance(name, customElementConstructor) {
    measurePerformance(name, customElementConstructor, {
        startFunction: "getDerivedStateFromProps",
        endFunction: "componentDidMount",
        name: RenderLifecyclePerformanceMeasure
    });
}
function measureReactWebComponentPerformance(name, customElementConstructor) {
    measurePerformance(name, customElementConstructor, {
        startFunction: "mountReactComponent",
        endFunction: "mountReactComponent",
        name: RenderLifecyclePerformanceMeasure
    });
}
function measureCustomHtmlElementPerformance(name, customElementConstructor) {
    measurePerformance(name, customElementConstructor, {
        startFunction: "attributeChangedCallback",
        endFunction: "attributeChangedCallback",
        name: RenderLifecyclePerformanceMeasure
    });
}
function measureDireflowComponentPerformance(name, customElementConstructor) {
    measurePerformance(name, customElementConstructor, {
        startFunction: "mountReactApp",
        endFunction: "mountReactApp",
        name: RenderLifecyclePerformanceMeasure
    });
}
function warnOnUnknownComponent(name, customElementConstructor) {
    StructuredLog.warn("Performance/UnknownComponentType", "Not measuring render performance", {
        name,
        prototype: Object.getOwnPropertyNames(customElementConstructor === null || customElementConstructor === void 0 ? void 0 : customElementConstructor.prototype)
    });
}
const measurePerformanceFunctionMap = new Map([
    [ComponentType.LitElement, measureLitElementPerformance],
    [ComponentType.ReactClassComponent, measureReactClassComponentPerformance],
    [ComponentType.ReactWebComponent, measureReactWebComponentPerformance],
    [ComponentType.CustomHtmlElement, measureCustomHtmlElementPerformance],
    [ComponentType.DireflowComponent, measureDireflowComponentPerformance],
    [ComponentType.Unknown, warnOnUnknownComponent]
]);
export class RenderPerformanceMeasure {
    constructor(componentType) {
        this.measurePerformanceStrategy = measurePerformanceFunctionMap.get(componentType);
    }
    measurePerformance(name, customElementConstructor) {
        this.measurePerformanceStrategy(name, customElementConstructor);
    }
}
